module.exports = __webpack_public_path__ + "img/188.6fce03d7.png";